<template>
  <div class="card">
    <div class="card-header">
      <h6>Crear staff (agente o supervisor)</h6>
    </div>
    <div class="card-body px-4">
      <form @submit.prevent="create">
        <div class="row">
          <div class="col">
            <label>Nombre</label>
            <input type="text" class="form-control" v-model="form.name">
            <label>Correo electrónico</label>
            <input type="email" class="form-control" v-model="form.email">
            <label>Contraseña</label>
            <input type="text" class="form-control" v-model="form.password">
            <label>Rol</label>
            <select class="form-control" v-model="form.type">
              <option value="agent">Agente</option>
              <option value="supervisor">Supervisor</option>
            </select>
          </div>
          <div class="col">
            <label>Identificación</label>
            <input type="text" class="form-control" v-model="form.identification">
            <label>Teléfono</label>
            <input type="text" class="form-control" v-model="form.phone">
            <label>País</label>
            <input type="text" class="form-control" v-model="form.country">
            <label>IP autorizada (obligatoria para poder iniciar sesión)</label>
            <input type="text" class="form-control" v-model="form.allowed_ip" placeholder="Ej: 190.25.13.40">
            <button type="submit" class="btn bg-gradient-success mt-4 w-100"> Crear staff</button>
          </div>
        </div>
      </form>
      <p class="text-xs text-secondary mt-3 mb-0">
        Nota: el agente/supervisor NO podrá iniciar sesión hasta que tenga una IP asignada,
        y solo podrá entrar desde esa IP.
      </p>
    </div>
  </div>
</template>

<script>
import {post} from "@/utils/httpRequest";

export default {
  name: "staff-create",
  data: () => ({
    form: {
      name: '',
      email: '',
      password: '',
      type: 'agent',
      identification: '',
      phone: '',
      country: '',
      allowed_ip: '',
    }
  }),
  methods: {
    async create(){
      if(this.form.name === '' || this.form.email === '' || this.form.password === ''){
        this.$swal({
          html: 'Nombre, correo y contraseña son obligatorios',
          icon: 'error',
          timer: 2500,
          showCancelButton: false,
          showConfirmButton: false,
        });
        return
      }
      const {data} = await post('users/create-staff', this.form, true)
      if(data && data.statusCode === 200){
        this.$swal({
          html: 'Staff creado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
        this.$router.push('/staff')
      }else{
        this.$swal({
          html: (data && data.message) || 'No se pudo crear el staff',
          icon: 'error',
          timer: 2500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
  .margin_top_mobile {
    margin-top: 1.5rem !important;
  }
}
</style>
